export default "* Instrumenter\n* Lyde\n* Klang\n* Samspil";